import React from 'react';

/**
 * Compact, interactive KPI counter cards for technician workflow
 */
const WorksheetKpiCards = ({ kpi, activeFilter, onFilterChange, currentUserId }) => {
  const cards = [
    {
      id: 'my-work',
      title: 'My Work',
      count: kpi?.myWorkCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-inprogress',
      icon: '👤',
      applyFilter: { assignedToMe: true, status: null, priority: null }
    },
    {
      id: 'stat',
      title: 'STAT',
      count: kpi?.statCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-stat',
      icon: '⚡',
      applyFilter: { priority: 'STAT', assignedToMe: false }
    },
    {
      id: 'tat-risk',
      title: 'TAT Risk',
      count: kpi?.tatRiskCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-tat',
      icon: '⏱️',
      applyFilter: { tatRiskOnly: true, assignedToMe: false }
    },
    {
      id: 'pending',
      title: 'Pending',
      count: kpi?.pendingCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-pending',
      icon: '⏳',
      applyFilter: { status: 'Pending', assignedToMe: false, tatRiskOnly: false }
    },
    {
      id: 'inprogress',
      title: 'In Progress',
      count: kpi?.inProgressCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-inprogress',
      icon: '🔬',
      applyFilter: { status: 'In Progress', assignedToMe: false, tatRiskOnly: false }
    },
    {
      id: 'hold',
      title: 'On Hold',
      count: kpi?.holdCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-hold',
      icon: '⏸️',
      applyFilter: { status: 'Hold', assignedToMe: false, tatRiskOnly: false }
    },
    {
      id: 'completed',
      title: 'Completed',
      count: kpi?.completedCount ?? 0,
      className: 'ws-kpi-card',
      borderClass: 'ws-kpi-completed',
      icon: '✓',
      applyFilter: { status: 'Completed', assignedToMe: false, tatRiskOnly: false }
    }
  ];

  return (
    <div className="ws-kpi-container">
      {cards.map((card) => {
        const isActive = activeFilter === card.id;
        return (
          <div
            key={card.id}
            className={`${card.className} ${card.borderClass} ${isActive ? 'active' : ''}`}
            onClick={() => onFilterChange(card.id, card.applyFilter)}
            title={`Click to filter: ${card.title}`}
          >
            <div className="ws-kpi-title">
              <span>{card.icon}</span>
              <span>{card.title}</span>
            </div>
            <div className="ws-kpi-value">{card.count}</div>
          </div>
        );
      })}
    </div>
  );
};

export default WorksheetKpiCards;
